let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fIJ95")).then(() => parcelRequire('3xm6B'));